import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { site } from '../data/site';
import { Reveal } from './Reveal';
const CTA_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/b90cf1f2-155c-4a5c-ac09-a7b981d25b9f.jpg';
export function EstimateCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const reduceMotion = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-8%', reduceMotion ? '-8%' : '8%']);
  return <section ref={sectionRef} className="relative isolate flex min-h-[70vh] items-center overflow-hidden bg-navy-900" data-id="element-91" data-mp="3suiymzt89bq8">
      <motion.img src={CTA_IMAGE} alt="" aria-hidden="true" loading="lazy" style={{
      y
    }} className="absolute inset-0 -z-10 h-[116%] w-full object-cover" data-id="element-92" data-mp="3jwguibe762yq" />
      <div className="absolute inset-0 -z-10 bg-navy-900/80" aria-hidden="true" data-id="element-93" data-mp="31zaeu6v4w1da" />

      <div className="mx-auto w-full max-w-[1400px] px-5 py-24 text-center sm:px-8 sm:py-32" data-id="element-94" data-mp="36rttl75k52jo">
        <Reveal data-id="element-95" data-mp="2t0oohpjf7i1y">
          <h2 className="mx-auto max-w-4xl font-display text-[clamp(2.2rem,5.5vw,4.4rem)] leading-[1.03] tracking-[-0.02em] text-white" data-id="element-96" data-mp="2t18abhc6yql9">
            Ready to Make Your Home
            <span className="block italic text-brass-light" data-id="element-97" data-mp="3krw7yjenpdu6">Unbelievable?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-98" data-mp="3pomn94in05ej">
          <p className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-99" data-mp="3pntnwom0ci6f">
            Tell us what you have in mind and let&rsquo;s talk about your next project.
          </p>
        </Reveal>
        <Reveal delay={0.18} data-id="element-100" data-mp="20azmp9yvzdza">
          <div className="mt-11 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-101" data-mp="20aq6uf7k2n7b">
            <a href="#contact" className="group inline-flex items-center justify-center gap-3 rounded-full bg-brass px-9 py-4 text-xs font-bold uppercase tracking-[0.18em] text-navy-900 transition-all duration-300 hover:bg-brass-light hover:shadow-[0_18px_40px_-18px_rgba(192,149,79,1)]" data-id="element-102" data-mp="259t3pcddtn47">
              Get Your Free Estimate
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-103" data-mp="11yay73z6ktf" />
            </a>
            <a href={site.phoneHref} className="inline-flex items-center justify-center gap-3 rounded-full border border-white/30 px-9 py-4 text-xs font-bold uppercase tracking-[0.18em] text-white transition-all duration-300 hover:border-white/60 hover:bg-white/10" data-id="element-104" data-mp="3oa21vr911iij">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-105" data-mp="3ab2eso15xboh" />
              Call Unbelievable
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}